import { apiClient } from './api';

export type InquiryStatus = 'NEW' | 'IN_PROGRESS' | 'CONTACTED' | 'COMPLETED';
export type InquirySource = 'WEBSITE' | 'AI_ASSISTANT';

export interface Inquiry {
  id: string;
  name: string;
  phone?: string | null;
  email?: string | null;
  serviceOfInterest?: string | null;
  message?: string | null;
  status: InquiryStatus;
  source: string;
  remarks?: string | null;
  updatedBy?: string | null;
  salonId: string;
  createdAt: string;
  updatedAt: string;
}

export interface InquiryFilters {
  status?: string;
  source?: string;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface CreateInquiryData {
  name: string;
  phone?: string;
  email?: string;
  serviceOfInterest?: string;
  message?: string;
  source?: InquirySource;
}

export interface UpdateInquiryData {
  status?: InquiryStatus;
  remarks?: string;
}

class InquiryService {
  private baseUrl = '/inquiries';

  async getInquiries(filters: InquiryFilters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
    });
    const res = await apiClient.get<{ data: { inquiries: Inquiry[] }; pagination?: any }>(
      `${this.baseUrl}?${params}`
    );
    return {
      inquiries: res?.data?.inquiries ?? [],
      pagination: res?.pagination
    };
  }

  async getInquiryById(id: string) {
    const res = await apiClient.get<{ data: { inquiry: Inquiry } }>(`${this.baseUrl}/${id}`);
    return (res as any)?.data?.inquiry ?? null;
  }

  async createInquiry(data: CreateInquiryData) {
    const res = await apiClient.post<{ data: { inquiry: Inquiry } }>(this.baseUrl, data);
    return (res as any)?.data?.inquiry ?? res;
  }

  async updateInquiry(id: string, data: UpdateInquiryData) {
    const res = await apiClient.patch<{ data: { inquiry: Inquiry } }>(`${this.baseUrl}/${id}`, data);
    return (res as any)?.data?.inquiry ?? res;
  }

  async deleteInquiry(id: string) {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }
}

export const inquiryService = new InquiryService();
